import React from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import IcomoonReact from 'icomoon-react';

import PropTypes from 'prop-types';
import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import { setTriOptionModal } from '../../../../sport-coach-dashboard/ducks/sportCoachDashboardActions';
import { setLMTriOptionModal } from '../../../../load-monitoring-dashboard/ducks/loadMonitoringDashboardActions';
import { setFPTriOptionModal } from '../../../../force-plate-dashboard/ducks/forcePlateDashboardActions';
import { setOptionVTDashModal } from '../../../../volume-tracker-dashboard/ducks/volumeTrackerDashboardActions';
import { dashboardTracker } from '../../../../../shared/utils/amplitudeHelper';

const MenuContainer = styled('div')`
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin-bottom: 10px;
  margin-right: 20px;
  border-radius: 50%;
  background-color: #1787fb;
  width: 55px;
  height: 55px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.isBlurred ? 'default' : 'pointer')};
  filter: ${(props) => (props.isBlurred ? 'blur(1.2px)' : null)};
`;

const SharedTemplateTriOptionMenuButton = ({ dashboard, legacyName, disabled, isBlurred }) => {
  const dispatch = useDispatch();
  let setTriOptionModalShowing = () => {};

  if (dashboard === 'Load Monitoring') {
    setTriOptionModalShowing = setLMTriOptionModal;
  }

  if (dashboard === 'Force Plate') {
    setTriOptionModalShowing = setFPTriOptionModal;
  }

  if (dashboard === 'KPI Tracker') {
    setTriOptionModalShowing = setTriOptionModal;
  }

  if (dashboard === 'Volume Tracker') {
    setTriOptionModalShowing = setOptionVTDashModal;
  }

  const handleMenuClick = () => {
    // Amplitude tracking
    dashboardTracker(
      `${legacyName} Dashboard`,
      'Dashboard Options Menu',
      'Modal opened',
    );
    if (disabled) return;
    dispatch(setTriOptionModalShowing(true));
  };

  return (
    <MenuContainer onClick={handleMenuClick} isBlurred={isBlurred}>
      <IcomoonReact
        iconSet={iconSet}
        size={25}
        icon='dots'
        color='#FFFFFF'
        style={{ rotate: '90deg' }}
      />
    </MenuContainer>
  );
};

SharedTemplateTriOptionMenuButton.defaultProps = {
  dashboard: 'Wearables',
  legacyName: 'Wearables',
  disabled: false,
  isBlurred: false,
};

SharedTemplateTriOptionMenuButton.propTypes = {
  dashboard: PropTypes.string,
  legacyName: PropTypes.string,
  disabled: PropTypes.bool,
  isBlurred: PropTypes.bool,
};

export default SharedTemplateTriOptionMenuButton;
